import React from 'react';
import PropTypes from 'prop-types';
import SearchBarInput from '../../SearchBarInput';
import { DEFAULT_FALLBACK_LANGUAGE } from 'Constants/App';

const SearchBox = (props) => {
    const {
        className, searchValue, onSearch, onBlur, onFocus,
        onKeyPress, reference, disabled, boldText, onClick, language,
    } = props;

    const classNames = `${className} search-box-input ${boldText ? 'closed text-bold' : ''}`;
    return (
        <SearchBarInput
            className={classNames}
            icon="search"
            reference={reference}
            onKeyPress={onKeyPress}
            onBlur={onBlur}
            onFocus={onFocus}
            onChange={onSearch}
            iconPosition="left"
            value={searchValue}
            onClick={onClick}
            disabled={disabled}
            language={language}
        />
    );
};

SearchBox.defaultProps = {
    className   : '',
    searchValue : '',
    onKeyPress  : () => {},
    onBlur      : () => {},
    onFocus     : () => {},
    onClick     : () => {},
    reference   : null,
    disabled    : false,
    boldText    : false,
    language    : DEFAULT_FALLBACK_LANGUAGE,
};

SearchBox.propTypes = {
    className   : PropTypes.string,
    onSearch    : PropTypes.func.isRequired,
    onBlur      : PropTypes.func,
    onKeyPress  : PropTypes.func,
    onFocus     : PropTypes.func,
    searchValue : PropTypes.string,
    disabled    : PropTypes.bool,
    boldText    : PropTypes.bool,
    onClick     : PropTypes.func,
    language    : PropTypes.string,
    // empty ref shape because of this https://github.com/facebook/prop-types/issues/240
    reference   : PropTypes.shape({}),
};

export default SearchBox;

